'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { motion } from 'framer-motion';
import { fadeInUp, staggerContainer, viewportOnce } from '@/lib/animations';
import { Building, Users, ShieldCheck, Bolt, Calendar } from 'lucide-react';

export default function Statistics() {
  const t = useTranslations('Statistics');

  const items = [
    {
      id: 'licensed_by',
      labelKey: 'label_licensed_by',
      valueKey: 'value_bank_of_albania',
      icon: (
        <Building color='#515050'/>
      ),
    },
    {
      id: 'empsa',
      labelKey: 'label_empsa',
      valueKey: 'value_member',
      icon: (
        <Users color='#515050'/>
      ),
    },
    {
      id: 'iso',
      labelKey: 'label_iso_27001',
      valueKey: 'value_iso_20022',
      icon: (
        <ShieldCheck color='#515050'/>
      ),
    },
    {
      id: 'tips',
      labelKey: 'label_tips_clone',
      valueKey: 'value_ready',
      icon: (
        <Bolt color='#515050'/>
      ),
    },
    {
      id: 'founded',
      labelKey: 'label_founded',
      valueKey: 'value_2010',
      icon: (
        <Calendar color='#515050'/>
      ),
    },
  ];

  return (
    <section className="w-full bg-white py-6 px-4 sm:px-6 lg:px-8 border-y border-gray-100">
      <motion.div
        className="max-w-8xl mx-auto flex flex-wrap md:flex-nowrap items-center justify-around gap-y-6 md:gap-y-0"
        initial="hidden"
        whileInView="visible"
        viewport={viewportOnce}
        variants={staggerContainer(0.1)}
      >
        {items.map((item, index) => (
          <React.Fragment key={item.id}>
            <motion.div variants={fadeInUp} className="flex items-center gap-3 px-2 sm:px-4 min-w-[160px] md:min-w-0">
              {item.icon}
              <div className="flex flex-col">
                <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider leading-none mb-1">
                  {t(item.labelKey)}
                </span>
                <span className="text-xs sm:text-sm font-bold text-gray-900 leading-tight">
                  {t(item.valueKey)}
                </span>
              </div>
            </motion.div>

            {/* Vertical Divider (Hidden on mobile grid wrap, shown on desktop) */}
            {index < items.length - 1 && (
              <div className="hidden md:block w-px h-8 bg-gray-200 shrink-0" />
            )}
          </React.Fragment>
        ))}
      </motion.div>
    </section>
  );
}